export class FinancialSpendEntry {
    ID: string;
    Deliverable: string;
    Category: string;
    Unit_Desc: string;
    units_budgeted: number;
    Latest_Invoice: string;
    Billed_to_Date: number;
    cost_budgeted: number;
    est_spending: number;
    est_units: number;
    Overspending_Units: number;
    Overspending_Cost: number;
    source: string;
    isOverspent: boolean;
    Platform: string;
    IdSort: number;


    Billed_to_Date_Display: string;
    cost_budgeted_Display: string;
    est_spending_Display: string;
    Overspending_Cost_Display: string;
    AllPlatformsDisplay: string;
    CategorySort: number;
    units_budgeted_Display: string;
    est_units_Display: string;
    Overspending_Units_Display: string
    Category_Display: string;
    isOverspent_Display: string;

    initialize(): void {
        this.Overspending_Cost = Math.round(this.Overspending_Cost);
        const result = this.ID.replace(/[a-zA-Z]/g, '');
        this.IdSort = parseFloat(result);

        this.Billed_to_Date_Display = this.displayCurrency(Math.round(this.Billed_to_Date));
        this.cost_budgeted_Display = this.displayCurrency(Math.round(this.cost_budgeted));
        this.est_spending_Display = this.displayCurrency(Math.round(this.est_spending));
        this.Overspending_Cost_Display = this.displayCurrency(Math.round(this.Overspending_Cost));
        this.units_budgeted_Display = this.displayUnits(this.units_budgeted);
        this.est_units_Display = this.displayUnits(this.est_units);
        this.Overspending_Units_Display = this.displayUnits(this.Overspending_Units);
        this.AllPlatformsDisplay = `<span style="cursor: pointer"><i class="fa-solid fa-arrow-up-right-from-square"></i>  ${this.Platform}</span>`;
        this.Category_Display = `<span style="cursor: pointer; text-decoration: underline; font-weight: bold;">${this.Category}</span>`;
        if (this.CategorySort != 1) {
            this.CategorySort = 2;
        }
        if (this.isOverspent) {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square-check"></i></span>`;
        }
        else {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square"></i></span>`;
        }
    }

    displayCurrency(amount: number) {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0, // No decimal places
            maximumFractionDigits: 0, // No decimal places
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return USDollar.format(amount);
        }
    }

    displayUnits(amount: number) {
        let numberFormatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return numberFormatter.format(amount);
        }
    }


}